







































import Vue from "vue";

// Vuex
import { RootState } from "@/store";
import { mapState, mapActions } from "vuex";
import * as a from "@/store/modules/ApplicationModule/actions";
import { Branch } from "@/model/data/Branch";

export default Vue.extend({
    data() {
        return {
            loading: false,
            selectedItems: [],
            lastSelectedItemsLength: 0,
            search: "",
            openMenu: false,
        };
    },
    computed: {
        ...mapState({
            availableBranches: (state: RootState) => state.application.availableBranches,
        }),

        availableBranchNames() {
            if (this.availableBranches && this.availableBranches.length > 0) {
                let sortedBranches = [];
                this.availableBranches
                    .map((b: Branch) => b.name)
                    .forEach((branch) => {
                        sortedBranches.push({ name: branch, selected: this.selectedItems.includes(branch) ? 1 : 0 });
                    });
                sortedBranches.sort((a, b) => {
                    return b.selected - a.selected || a.name.localeCompare(b.name);
                });
                return sortedBranches;
            } else return [];
        },
    },
    methods: {
        ...mapActions([a.GET_AVAILABLE_BRANCHES]),

        filter() {
            this.$emit("input", this.selectedItems);
            this.lastSelectedItemsLength = this.selectedItems.length;
            this.openMenu = false;
            this.search = "";
        },
    },
    async mounted() {
        this.loading = true;

        if (this.availableBranchNames == null || !this.availableBranchNames.length) await this[a.GET_AVAILABLE_BRANCHES]();
        this.loading = false;
    },
});
